import type { Institucion, UsuarioConAccesos } from "@/shared/api";

/** Mismo formato que exige la API: el código de la institución en SimplGo. */
export const FORMATO_CODIGO = /^[A-Z0-9_]{2,32}$/;

export function normalizarCodigo(codigo: string): string {
  return codigo.trim().toUpperCase();
}

export type ErrorInstitucion = "codigo" | "nombre" | "existe";

export function validarRegistro(
  codigo: string,
  nombre: string,
  existentes: readonly Institucion[],
): ErrorInstitucion | null {
  const c = normalizarCodigo(codigo);
  if (!FORMATO_CODIGO.test(c)) return "codigo";
  if (!nombre.trim()) return "nombre";
  if (existentes.some((i) => i.institucion === c)) return "existe";
  return null;
}

export function habilitadas(lista: readonly Institucion[]): Institucion[] {
  return lista.filter((i) => i.habilitada).sort((a, b) => a.nombre.localeCompare(b.nombre, "es"));
}

/** Nombre registrado de cada código, para mostrar «Nombre (CÓDIGO)» en vez del código solo. */
export function nombres(lista: readonly Institucion[]): ReadonlyMap<string, string> {
  return new Map(lista.map((i) => [i.institucion, i.nombre]));
}

/** Cuántos usuarios tienen hoy un acceso activo a cada institución. */
export function usuariosPorInstitucion(usuarios: readonly UsuarioConAccesos[]): ReadonlyMap<string, number> {
  const cuenta = new Map<string, number>();
  for (const u of usuarios) {
    for (const a of u.accesos) {
      if (a.estado === "activo") cuenta.set(a.institucion, (cuenta.get(a.institucion) ?? 0) + 1);
    }
  }
  return cuenta;
}
